var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmRightBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74701",
    "data-name": "Group 74701",
    transform: "translate(12656 -13533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74721",
    "data-name": "Group 74721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    transform: "translate(-12656 13533)",
    fill: "none",
    stroke: "#1bbc8d",
    strokeWidth: 4,
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 53.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M58.49,16.141,27.736,47.455,13.756,33.221",
    transform: "translate(-12636.418 13556.908)",
    fill: "none",
    stroke: "#1bbc8d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmRightBig);
export default __webpack_public_path__ + "static/media/ConfirmRightBig.afbace7886e8a0293427f0061b50d089.svg";
export { ForwardRef as ReactComponent };